import type {
  ColorPalette,
  CustomColorPalette,
} from '../../core/types/color-palette.js';
import { getColorPalette } from '../../core/utils/get-color-palette.js';
import type {
  CategoricalLegendColorMap,
  InternalTreeMapNode,
  LegendColorMap,
} from '../types/internal.js';
import type { NameAccessor } from '../types/treemap.js';

/**
 * Function to map clusters or nodes to color tokens
 * @param rootNode - InternalTreeMapNode
 * @param colorPalette - color palette
 * @param nameAccessor - targeted property on the leaf node
 * @returns - LegendColorMap
 */
export const getCategoricalLegendColorMap = (
  rootNode: InternalTreeMapNode,
  colorPalette: ColorPalette | CustomColorPalette,
  nameAccessor: NameAccessor | undefined,
) => {
  const legendColorMap: LegendColorMap = new Map() as CategoricalLegendColorMap;
  let colorIdx = 0;

  rootNode.children?.forEach((cluster) => {
    if (nameAccessor) {
      cluster.children?.forEach((node) => {
        const labelKey = node[nameAccessor] as string;
        if (!legendColorMap.has(labelKey)) {
          const colorToken = getColorPalette(labelKey, colorIdx, colorPalette);
          legendColorMap.set(labelKey, { color: colorToken });
          colorIdx++;
        }
      });
    } else {
      const labelKey = cluster.name;
      if (!legendColorMap.has(labelKey)) {
        const colorToken = getColorPalette(labelKey, colorIdx, colorPalette);
        legendColorMap.set(labelKey, {
          color: colorToken,
          value: cluster.value,
        });
        colorIdx++;
      }
    }
  });

  return legendColorMap;
};
